import ErrorKeyEnum from './enum/ErrorKeyEnum';

class ValidationManager {
  #IsTriggered = false;
  #ErrorMessages = [];

  constructor(messages = [], triggered = null) {
    this.#ErrorMessages = messages;
    this.#IsTriggered = triggered === null ? messages.length > 0 : triggered;
  }

  get isTriggered() {
    return this.#IsTriggered;
  }

  hasError(programServiceId, errorId) {
    if (
      !this.#IsTriggered ||
      this.#ErrorMessages.length == 0 ||
      !programServiceId
    )
      return false;

    return !!this.#ErrorMessages.find(
      (error) => error.id?.includes(`${errorId}-${programServiceId}`)
    );
  }

  hasResultSummarySectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.ResultSummary);
  }

  hasSubAreaSectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.SubArea);
  }

  hasProcedureSectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.Procedure);
  }

  hasNecessitySectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.Necessity);
  }

  hasStrengthSectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.Strength);
  }

  hasLevelSectionError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.Level);
  }

  hasSkillSectionError(programServiceId) {
    return (
      this.hasNecessitySectionError(programServiceId) ||
      this.hasStrengthSectionError(programServiceId)
    );
  }

  hasGoalsError(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.GoalsCountError);
  }

  minGoalsRequired(programServiceId) {
    const error = this.#ErrorMessages.find(
      error => error.id?.includes(`${ErrorKeyEnum.GoalsCountError}-${programServiceId}`)
    );
    
    if (!error?.id?.length)
      return 1;

    const minRequiredValue = Number(error.id.split("#")[1])
    return minRequiredValue;
  }

  hasObjetiveEmpty(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.GoalWithoutObjetive);
  }

  hasGoalWithoutNecessity(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.GoalWithoutNecessity);
  }

  hasSubAreaWithoutGoal(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.SubAreaWithoutGoal);
  }

  hasIncompleteNecessitySelection(programServiceId) {
    return this.hasError(programServiceId, ErrorKeyEnum.NecessitySelection);
  }

  hasCompensationServiceInvalid(programServiceId) {
    return this.hasError(
      programServiceId,
      ErrorKeyEnum.CompensationServiceInvalid
    );
  }

  hasEducationalCompensationCurrentServiceUnanswered() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) =>
        error.id ===
        ErrorKeyEnum.EducationalCompensationCurrentServiceUnanswered
    );
  }

  hasEducationalCompensationPreviousServiceUnanswered() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) =>
        error.id ===
        ErrorKeyEnum.EducationalCompensationPreviousServiceUnanswered
    );
  }

  isYesSelectedOnCurrentWithoutServices() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) => error.id === ErrorKeyEnum.isYesSelectedOnCurrentWithoutServices
    );
  }

  isYesSelectedOnPreviousWithoutServices() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) =>
        error.id === ErrorKeyEnum.isYesSelectedOnPreviousWithoutServices
    );
  }

  isNoSelectedOnCurrentWithServices() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) => error.id === ErrorKeyEnum.isNoSelectedOnCurrentWithServices
    );
  }

  hasAtLeastOneDocumentedWhenYes() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) => error.id === ErrorKeyEnum.hasAtLeastOneDocumentedWhenYes
    );
  }
  hasAtLeastOneDocumentedWhenNo() {
    if (!this.#IsTriggered || this.#ErrorMessages.length === 0) return false;

    return !!this.#ErrorMessages.find(
      (error) => error.id === ErrorKeyEnum.hasAtLeastOneDocumentedWhenNo
    );
  }

  hasGoalSectionError(programServiceId) {
    return (
      this.hasGoalsError(programServiceId) ||
      this.hasObjetiveEmpty(programServiceId) ||
      this.hasGoalWithoutNecessity(programServiceId) ||
      this.hasSubAreaWithoutGoal(programServiceId) ||
      this.hasIncompleteNecessitySelection(programServiceId)
    );
  }
}

export { ValidationManager };
